import { Icon } from "../Icon.jsx";

export function OrdersCommandHeader({
  actions,
  contextLabel,
  pagination,
  subtitle,
  syncStatus,
  title,
}) {
  return (
    <header className="orders-command-header">
      <div className="orders-command-header__identity">
        <span className="orders-command-header__eyebrow">Kontrol Operasional</span>
        <div className="orders-command-header__title-row">
          <h1>{title}</h1>
          <span className="orders-command-header__context">{contextLabel}</span>
        </div>
        <p>{subtitle}</p>
      </div>

      <div className="orders-command-header__system" aria-label="Status data pesanan">
        <span className="orders-command-header__system-icon" aria-hidden="true">
          <Icon name="sync" size={18} />
        </span>

        <div className="orders-system-status">
          <span className="orders-system-status__label">Sinkronisasi Accurate</span>
          {syncStatus}
        </div>

        {pagination && (
          <div className="orders-header-pagination">
            <span className="orders-system-status__label">Rentang Data</span>
            {pagination}
          </div>
        )}
      </div>

      <div className="orders-command-header__actions">{actions}</div>
    </header>
  );
}

const ORDER_TABS = [
  {
    id: "pending",
    icon: "orders",
    label: "Perlu Diproses",
    description: "Tinjau dan jadwalkan pesanan aktif",
  },
  {
    id: "processed",
    icon: "check",
    label: "Terproses",
    description: "Tinjau dan jadwalkan Sales Order terproses",
  },
];

export function OrdersWorkspaceTabs({ activeTab, onChange }) {
  return (
    <div className="orders-workspace-tabs" aria-label="Mode kerja Pesanan" role="tablist">
      {ORDER_TABS.map((tab) => {
        const active = activeTab === tab.id;

        return (
          <button
            aria-selected={active}
            className={active ? "is-active" : ""}
            key={tab.id}
            onClick={() => onChange(tab.id)}
            role="tab"
            tabIndex={active ? 0 : -1}
            type="button"
          >
            <span className="orders-workspace-tabs__icon" aria-hidden="true">
              <Icon name={tab.icon} size={17} />
            </span>
            <span>
              <strong>{tab.label}</strong>
              <small>{tab.description}</small>
            </span>
          </button>
        );
      })}
    </div>
  );
}

export function OrdersKpiStrip({ children, label }) {
  return (
    <section aria-label={label} className="orders-kpi-section">
      <header className="orders-kpi-section__header">
        <span>
          <Icon name="database" size={13} />
          {label}
        </span>
        <small>Seluruh hasil filter aktif</small>
      </header>
      <div className="orders-kpi-strip">{children}</div>
    </section>
  );
}

export function OrdersFilterWorkbench({
  activeFilters,
  children,
  description,
  note = "Perubahan diterapkan setelah menekan Terapkan.",
  title,
}) {
  return (
    <section className="orders-filter-workbench" aria-label={title}>
      <header className="orders-filter-workbench__heading">
        <div>
          <span className="orders-filter-workbench__icon" aria-hidden="true">
            <Icon name="filter" size={15} />
          </span>
          <div>
            <strong>{title}</strong>
            <span>{description}</span>
          </div>
        </div>
        <small>{note}</small>
      </header>

      {children}
      {activeFilters}
    </section>
  );
}

export function ActiveFilterSummary({ labels, onClear, showClear = true }) {
  return (
    <div className="orders-active-filters" aria-live="polite">
      <span className="orders-active-filters__label">Filter aktif</span>

      <div className="orders-active-filters__chips">
        {labels.length ? (
          labels.map((label) => <span key={label}>{label}</span>)
        ) : (
          <span className="is-neutral">Semua data sesuai konteks tab</span>
        )}
      </div>

      {showClear && labels.length > 0 && (
        <button className="text-button" onClick={onClear} type="button">
          Bersihkan
        </button>
      )}
    </div>
  );
}

export function OrdersListHeader({
  children,
  context,
  description,
  eyebrow,
  title,
}) {
  return (
    <header className="orders-data-surface__header">
      <div>
        <span className="orders-data-surface__eyebrow">{eyebrow}</span>
        <h2>{title}</h2>
        <p>{description}</p>
        {children}
      </div>
      {context}
    </header>
  );
}

export function ContextualSelectionBar({
  actionDisabled,
  actionIcon = "route",
  actionLabel,
  idleText,
  onAction,
  onClear,
  selectedCount,
  selectedNoun = "dokumen",
}) {
  const active = selectedCount > 0;

  return (
    <section
      aria-live="polite"
      className={`orders-selection-bar${active ? " is-active" : " is-idle"}`}
    >
      <div className="orders-selection-bar__status">
        <span className="orders-selection-bar__icon" aria-hidden="true">
          <Icon name={active ? "check" : "orders"} size={17} />
        </span>
        <div>
          <strong>
            {active
              ? `${selectedCount} ${selectedNoun} dipilih`
              : `Belum ada ${selectedNoun} dipilih`}
          </strong>
          <span>{active ? "Pilihan siap dijadwalkan ke Fleet Order." : idleText}</span>
        </div>
      </div>

      <div className="orders-selection-bar__actions">
        {active && (
          <button className="text-button" onClick={onClear} type="button">
            Batalkan pilihan
          </button>
        )}

        <button
          className="primary-button"
          disabled={actionDisabled}
          onClick={onAction}
          type="button"
        >
          <Icon name={actionIcon} size={16} />
          {actionLabel}
        </button>
      </div>
    </section>
  );
}
